export const EMAIL = 'mailto:barblopez8@gmail.com'
export const INSTAGRAM = 'https://www.instagram.com/iambarbaralopez'
export const LINKEDIN = 'https://www.linkedin.com/in/iambarbaralopez'
export const SAVEE = 'https://www.savee.it/iambarbaralopez/'
